export const Key = {
  cookie: {
    access_token_key: 'Authentik_Session',
    user_data: 'User_Data',
  },
  storage:{
    locale:'locale'
  },
  language:{
    default:'de',
    english:'en'
  }
};
